"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./UploadComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UploadComponent = function UploadComponent(_ref) {
  var className = _ref.className,
      accept = _ref.accept,
      beforeUpload = _ref.beforeUpload,
      customRequest = _ref.customRequest,
      defaultFileList = _ref.defaultFileList,
      directory = _ref.directory,
      disabled = _ref.disabled,
      fileList = _ref.fileList,
      headers = _ref.headers,
      maxCount = _ref.maxCount,
      multiple = _ref.multiple,
      previewFile = _ref.previewFile,
      progress = _ref.progress,
      onChange = _ref.onChange,
      onPreview = _ref.onPreview,
      onRemove = _ref.onRemove,
      onDrop = _ref.onDrop,
      withCredentials = _ref.withCredentials,
      showUploadList = _ref.showUploadList,
      openFileDialogOnClick = _ref.openFileDialogOnClick,
      name = _ref.name,
      listType = _ref.listType,
      isImageUrl = _ref.isImageUrl,
      iconRender = _ref.iconRender,
      child = _ref.child;
  return /*#__PURE__*/_react["default"].createElement(_antd.Upload, {
    accept: accept,
    beforeUpload: beforeUpload ? beforeUpload : function () {
      return false;
    },
    customRequest: customRequest,
    defaultFileList: defaultFileList,
    directory: directory ? directory : false,
    disabled: disabled ? disabled : false,
    fileList: fileList,
    headers: headers,
    maxCount: maxCount ? maxCount : 5,
    multiple: multiple ? multiple : false,
    previewFile: previewFile,
    progress: progress,
    onChange: onChange,
    onPreview: onPreview,
    onRemove: onRemove,
    onDrop: onDrop,
    withCredentials: withCredentials ? withCredentials : false,
    showUploadList: showUploadList,
    openFileDialogOnClick: openFileDialogOnClick ? openFileDialogOnClick : true,
    name: name || "Upload",
    listType: listType,
    isImageUrl: isImageUrl,
    iconRender: iconRender,
    className: "".concat(className ? className : "")
  }, child);
};

var _default = UploadComponent;
exports["default"] = _default;